import React, { useEffect, useState, useContext } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "./MyOrders.css";
import { BACKEND_URL } from "../../../config";

function MyOrders() {
  const { user, setShowAuth, setAuthMode } = useContext(AuthContext);
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  const loadOrders = async (userId) => {
    try {
      const response = await fetch(
        `${BACKEND_URL}/api.php?module=orders&action=get&user_id=${userId}`
      );
      const data = await response.json();
      setOrders(data.data || []);
    } catch (error) {
      console.log("ERROR:", error);
    } finally {
      setDataLoaded(true);
    }
  };

  useEffect(() => {
    setDataLoaded(false);

    if (!user) {
      setAuthMode("signin");
      setShowAuth(true);
      setOrders([]);
      setDataLoaded(true); 
    } else {
      loadOrders(user.id);
    }
  }, [user, setAuthMode, setShowAuth]);

  // ✅ ClientLayout spinner dikhega
  if (!dataLoaded) return null;

  return (
    <div className="myorders-page">
      <Helmet>
        <title>My Orders | Track Your Purchases</title>
        <meta name="description" content="View and track all your orders." />
        <meta name="robots" content="noindex, nofollow" />
          <link rel="canonical" href="https://kamagrastar.eu/my-orders" />
      </Helmet>

      <div className="myorders-header">
        <h1>My Orders</h1>
        <p>Track your orders and delivery status</p>
      </div>

      {!user ? (
        <div className="empty-orders">
          <p>Please login to view your orders.</p>
          <button onClick={() => { setAuthMode("signin"); setShowAuth(true); }}>
            Login
          </button>
        </div>
      ) : orders.length === 0 ? (
        <div className="empty-orders">
          <p>No orders found.</p>
        </div>
      ) : (
        <div className="myorders-table">
          <table>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Date</th>
                <th>Payment</th>
                <th>Total</th>
                <th>Status</th>
                <th>Invoice</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => {
                const status = (order.order_status || "pending").toLowerCase();
                const isInvoiceAllowed = status !== "pending" && status !== "cancelled";

                return (
                  <tr key={order.id}>
                    <td>#{order.id}</td>
                    <td>{order.created_at}</td>
                    <td>{order.payment_method}</td>
                    <td>€{order.total}</td>
                    <td>
                      <span className={`status ${order.order_status || "pending"}`}>
                        {order.order_status || "Pending"}
                      </span>
                    </td>
                    <td>
                      <button
                        className={`invoice-btn ${!isInvoiceAllowed ? "disabled" : ""}`}
                        disabled={!isInvoiceAllowed}
                        title={!isInvoiceAllowed ? "Invoice available once order is confirmed" : ""}
                        onClick={() => {
                          if (!isInvoiceAllowed) return;

                          const invoiceOrder = {
                            orderId: order.id,
                            invoiceNumber: `ORD-${String(order.id).padStart(6, "0")}`,
                            orderDate: order.created_at,
                            paymentMethod: order.payment_method,
                            shippingData: {
                              firstName: order.first_name,
                              lastName: order.last_name,
                              address: order.address,
                              city: order.city,
                              country: order.country,
                              phone: order.phone,
                            },
                            cart: (order.items || []).map(item => ({
                              productName: item.product_name,
                              price: Number(item.price),
                              qty: Number(item.qty),
                              image: item.image,
                              packSize: item.pack_size,
                            })),
                            subtotal: Number(order.subtotal),
                            shipping: Number(order.shipping_charge),
                            discount: Number(order.discount),
                            total: Number(order.total),
                          };

                          localStorage.setItem(
                            "lastOrder",
                            JSON.stringify(invoiceOrder)
                          );

                          navigate("/checkout/invoice");
                        }}
                      >
                        Invoice
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default MyOrders;